const NAME_SPACE = 'AccordionSlot';

export { NAME_SPACE };
